var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page-base',[_c('part-box',{staticClass:"max-w-box-sm w-full self-center justify-self-center"},[_c('template',{slot:"header"},[_c('icon-induline-logo',{staticClass:"mb-24 self-center"})],1),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }